<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
    <path fill="none" :stroke="color" :stroke-width="strokeWidth" d="M.7071.70705L9.1761 9.17605M.7071 9.17585L9.1761.70685"/>
  </svg>
</template>

<script>
  export default {
    name: 'icn-close',
    props: {
      color: {
        type: String,
        default: '#979DAD'
      },
      strokeWidth: {
        type: Number,
        default: 2
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'></style>
